import React from 'react';
import { useTranslation } from 'react-i18next';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { AudioGenerationStatus } from '@packages/global';

interface SearchBarProps {
  searchTerm: string;
  statusFilter: AudioGenerationStatus | '';
  onSearchTermChange: (term: string) => void;
  onStatusFilterChange: (status: AudioGenerationStatus | '') => void;
}

export default function SearchBar({
  searchTerm,
  statusFilter,
  onSearchTermChange,
  onStatusFilterChange
}: SearchBarProps) {
  const { t } = useTranslation(['generation', 'common']);

  return (
    <div className="mb-6">
      <div className="flex flex-col sm:flex-row gap-4">
        <div className="flex-1">
          <div className="relative">
            <MagnifyingGlassIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
            <input
              type="text"
              placeholder={t('audio.searchPlaceholder')}
              value={searchTerm}
              onChange={(e) => onSearchTermChange(e.target.value)}
              className="block w-full pl-10 pr-3 py-2 border border-border-subtle rounded-md leading-5 bg-bg-form placeholder-gray-400 focus:outline-none focus:placeholder-gray-300 focus:ring-1 focus:ring-primary focus:border-primary text-gray-50"
            />
          </div>
        </div>
        <select
          value={statusFilter}
          onChange={(e) => onStatusFilterChange(e.target.value as AudioGenerationStatus | '')}
          className="px-3 py-2 border border-border-subtle rounded-md focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary bg-bg-form text-gray-50"
        >
          <option value="">{t('audio.allStatus')}</option>
          {Object.values(AudioGenerationStatus).map(status => (
            <option key={status} value={status}>{t(`status.${status}`)}</option>
          ))}
        </select>
      </div>
    </div>
  );
}